// src/hooks/useCancelQrGenerationJob.ts
// README.md muc 13 — logic huy job sinh bo so & QR dung CHUNG cho ca 2 noi co the huy: nut Huy trong
// cot Thao tac (pages/SinhBoSoQr/index.tsx) va nut Huy trong popup tien trinh noi
// (Layouts/GlobalJobProgress.tsx, QrJobTracker). TRUOC DAY 2 noi tu viet rieng logic va KHAC NHAU o
// buoc sau khi API huy thanh cong — cot Thao tac co dieu huong sang /issuance-plans, popup tien
// trinh thi khong (chi dong popup, o lai trang hien tai) — gay trai nghiem khong nhat quan va la
// nguyen nhan khien man /issuance-plans "dung yen" voi du lieu cu neu nguoi dung tu chuyen trang sau
// khi huy tu popup thay vi duoc dieu huong thang toi. Gio ca 2 noi deu goi hook nay, thong nhat theo
// dung logic cua nut trong cot Thao tac (luon dieu huong sang issuance-plans ngay sau khi huy
// thanh cong, dam bao danh sach duoc tai lai voi trang thai moi nhat).
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { cancelQrGenerationJobApi } from 'helpers/fakebackend_helper';
import { removeActiveJob } from 'slices/sinhBoSoQr/reducer';

// Phat khi huy thanh cong — cac component dang hien thi tien do job nay (VD PlanStatusColumn) lang
// nghe de tu cap nhat ngay, khong doi polling phat hien qua trang thai "cancelled" (co the cham vai
// chuc giay). Dinh nghia 1 LAN DUY NHAT o day thay vi moi noi tu khai bao lai chuoi giong het nhau
// (de sai lech neu sau nay sua 1 noi ma quen noi khac).
export const QR_GENERATION_JOB_TERMINAL_EVENT = 'lms_qr_generation_job_terminal';

// Nem lai loi neu API huy that bai de caller tu quyet dinh hien thi/xu ly loi ra sao (VD co reload
// lai danh sach tai trang hien tai hay khong, tuy dac thu tung noi goi) — CHI KHI API xac nhan thanh
// cong moi chac chan don dep (Redux/localStorage/event) + dieu huong, tranh lap lai loi cu: 1 buoc
// don dep phu bi loi bat ngo lam hong ket qua da thanh cong (xem SinhBoSoQr/index.tsx lich su sua).
export const useCancelQrGenerationJob = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return useCallback(
    async (jobId: string, reason: string, lotteryPeriodId: number) => {
      await cancelQrGenerationJobApi(jobId, reason);

      try {
        dispatch(removeActiveJob(jobId));
        localStorage.removeItem(`lms_active_job_${lotteryPeriodId}`);
        window.dispatchEvent(new CustomEvent(QR_GENERATION_JOB_TERMINAL_EVENT));
      } catch (cleanupError) {
        // eslint-disable-next-line no-console
        console.error('Loi don dep sau khi huy job thanh cong (khong anh huong ket qua huy):', cleanupError);
      }

      navigate('/issuance-plans', { state: { refreshAt: Date.now() } });
    },
    [dispatch, navigate]
  );
};
